<template>
  <div>
    <!-- <div class="hello" ref="chartdiv" style="height:230px;"> -->
    <div class="hello" ref="chartdiv" style="height: 230px"></div>
  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
am4core.addLicense("ch-custom-attribution");
export default {
  name: "xyChart",
  props: {
    chart_data: {
      type: Array,
      require: true,
      default: () => {
        return {
          example: [],
          foo: [],
        };
      },
    },
  },
  watch: {
    chart_data: function (val) {
      this.xy_chart_setting(val);
    },
  },
  data: () => ({}),
  mounted() {},
  methods: {
    xy_chart_setting(val) {
      const max = this.chart_data.reduce(function (prev, current) {
        return prev.score > current.score ? prev : current;
      }); //

      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

      chart.data = val;

      chart.padding(40, 20, 0, -20);
      chart.maskBullets = false; // allow bullets to go out of plot area
      // category axis
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "categorySubject";
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.cellStartLocation = 0.2;
      categoryAxis.renderer.cellEndLocation = 0.8;
      categoryAxis.renderer.labels.template.fontSize = 10;
      var label = categoryAxis.renderer.labels.template;
      label.wrap = true;
      label.maxWidth = 80;
      label.textAlign = "middle";

      // value axis
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      // we set fixed min/max and strictMinMax to true, as otherwise value axis will adjust min/max while dragging and it won't look smooth
      valueAxis.strictMinMax = true;
      valueAxis.min = 0;
      valueAxis.max = max;
      valueAxis.renderer.minWidth = 0;
      valueAxis.renderer.grid.template.strokeOpacity = 0;
      valueAxis.renderer.labels.template.adapter.add("text", function () {
        return "";
      });
      // series
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.categoryX = "categorySubject";
      series.dataFields.valueY = "score";
      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.dy = -8;
      series.sequencedInterpolation = true;
      series.defaultState.interpolationDuration = 1500;
      series.columns.template.strokeOpacity = 0;
      series.columns.template.maxHeight = 10;

      // label bullet
      var labelBullet = new am4charts.LabelBullet();
      series.bullets.push(labelBullet);
      labelBullet.label.text = "{valueY.value.formatNumber('#,###')}";
      labelBullet.strokeOpacity = 0;
      labelBullet.stroke = am4core.color("#dadada");
      labelBullet.dy = -20;

      // series bullet
      var bullet = series.bullets.create();
      bullet.stroke = am4core.color("#ffffff");
      bullet.strokeWidth = 3;
      bullet.opacity = 1; // initially invisible
      bullet.defaultState.properties.opacity = 1;
      // resize cursor when over
      bullet.cursorOverStyle = am4core.MouseCursorStyle.verticalResize;
      bullet.draggable = true;

      // column template
      var columnTemplate = series.columns.template;
      columnTemplate.column.cornerRadiusTopLeft = 4;
      columnTemplate.column.cornerRadiusTopRight = 4;
      columnTemplate.column.fillOpacity = 1;
      columnTemplate.tooltipY = 0; // otherwise will point to middle of the column
      columnTemplate.column.fill = "#4cda64";
      columnTemplate.width = am4core.percent(120);
      columnTemplate.height = am4core.percent(50);
    },
  },
};
</script>
